import React from 'react';

interface PropertyDescriptionCardProps {
  description: string;
}

export const PropertyDescriptionCard: React.FC<PropertyDescriptionCardProps> = ({
  description,
}) => {
  return (
    <div className="bg-white rounded-2xl border border-slate-200/90 p-3.5 shadow-2xs">
      <div className="flex items-center gap-1.5 mb-1.5">
        <span className="w-1.5 h-3.5 rounded-full bg-[#f59e0b]" />
        <h3 className="text-xs font-black tracking-wider text-[#0a2540] uppercase">
          Descripción del Inmueble
        </h3>
      </div>
      <p className="text-xs text-slate-700 leading-normal text-left font-normal whitespace-pre-line pb-0.5">
        {description}
      </p>
    </div>
  );
};
